import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const WhatsNewPopup = ({ onClose, onDontShowAgain }) => {
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    console.log("WhatsNewPopup mounted");
  }, []);

  const handleClose = async () => {
    console.log("Closing popup. dontShow:", dontShow);
    if (dontShow) {
      console.log("Triggering onDontShowAgain()");
      try {
        await axios.post(
          "https://lykns00a87.execute-api.us-east-2.amazonaws.com/default/football_app_data_crud",
          {
            operationType: "disable_whats_new",
            data: { coach_id: localStorage.getItem("userId") },
          }
        );
      } catch (err) {
        console.error("Failed to disable What's New flag:", err);
      }
      onDontShowAgain();
    }
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
      }}
    >
      <motion.div
        style={{
          backgroundColor: "#fff",
          borderRadius: "1rem",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          width: "90%",
          maxWidth: "400px",
          padding: "1.5rem",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1.5rem",
        }}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          🚀 What's New!
        </h2>

        <div style={{ marginBottom: "1.5rem" }}>
          <p>
            <span style={{ fontWeight: "bold" }}>End of Season: </span> Players
            not staying with you? you can now archive instead of deleting them
            in the "Manage your Team" page
          </p>
          <p>
            <span style={{ fontWeight: "bold" }}>End of Season</span> Stats page
            now is season aware, new season starts in August, so you can now see
            your stats for the current season and previous seasons.
          </p>
        </div>

        <label
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1.5rem",
            fontSize: "0.9rem",
          }}
        >
          <input
            type="checkbox"
            style={{ marginRight: "0.5rem", width: "1rem", height: "1rem" }}
            checked={dontShow}
            onChange={(e) => {
              console.log("Checkbox toggled:", e.target.checked);
              setDontShow(e.target.checked);
            }}
          />
          Don't show this again
        </label>

        <button
          onClick={handleClose}
          style={{
            alignSelf: "center",
            width: "70%",
            backgroundColor: "#3B82F6",
            color: "white",
            fontWeight: "bold",
            padding: "0.75rem",
            borderRadius: "0.5rem",
            border: "none",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          Close
        </button>
      </motion.div>
    </div>
  );
};

export default WhatsNewPopup;
